import _ from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import RoleRequire from "@/helpers/auth/RoleRequire";
import { AdminDowntimesTable } from "@/types/formDataTypes";
import { Button } from "@/ui/Button";
import { Input } from "@/ui/Input/Input";
import { ColumnDef } from "@tanstack/react-table";
import { MenuDataTable } from "@/ui/DataTable/MenuDataTable";
import { DowntimesType } from "@/types/types";

export default function DowntimesGrid({
  downtimes,
  onClose,
}: {
  downtimes: DowntimesType[];
  onClose: () => void;
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [search, setSearch] = useState("");

  let nodes =
    downtimes.length > 0
      ? downtimes.map((data) => {
          return {
            id: String(data.id),
            name: data.name,
            description: data.description,
          };
        })
      : [];

  // Сортировка по умолчанию
  nodes = _.sortBy(nodes, []);
  let data = { nodes };

  const handleSearch = (event: any) => {
    setSearch(event.target.value);
  };

  // Фильтрация через поиск
  data = {
    nodes: data.nodes?.filter((item) =>
      search ? item.name?.toLowerCase().includes(search.toLowerCase()) : true,
    ),
  };

  const columns: ColumnDef<AdminDowntimesTable>[] = [
    {
      header: t("name"),
      size: 200,
      minSize: 200,
      maxSize: 200,
      cell: ({ row }) => row.original.name,
    },
    {
      header: t("description"),
      size: 400,
      minSize: 400,
      maxSize: 400,
      cell: ({ row }) => row.original.description,
    },
  ];

  function selectDowntime(downtime: any) {
    onClose();
  }

  function addAdminDowntime() {
    navigate("/admin/downtimes/new");
    onClose();
  }

  return (
    <>
      <div className="flex flex-col">
        <div className="flex flex-row w-full h-14 items-center gap-4 px-6 justify-between">
          <Input
            className="h-8"
            placeholder={t("search")}
            onChange={handleSearch}
            value={search}
            autoComplete="off"
            width="100%"
          />

          <RoleRequire role="maintainer">
            <Button
              variant={"default"}
              size={"md"}
              onClick={() => addAdminDowntime()}
            >
              {t("add")}
            </Button>
          </RoleRequire>
        </div>
      </div>

      {!data.nodes?.length ? ( // Заглушка для отсутствия данных при поиске
        <div className="flex w-full h-full justify-center items-center">
          {t("no_data")}
        </div>
      ) : (
        <MenuDataTable
          route="/admin/downtimes"
          data={data.nodes}
          columns={columns}
          onClickRow={selectDowntime}
        />
      )}
    </>
  );
}
